import React from "react";
import {Card, Col, Form, Input, Row, Skeleton} from "antd";
import {useFormik} from "formik";
import {useTranslation} from "react-i18next";
import {CustomButton} from "../../_defaultComponents/CustomButton/CustomButton";
import * as Sentry from "@sentry/react";
import {useStore} from "../../../hooks/useStore";

export const BillingInformationForm = ({subCompany, loading, refetch, isCustomer}) => {
    const stores = useStore();

    const {t} = useTranslation();

    const formik = useFormik({
        initialValues: {
            ...subCompany
        },
        enableReinitialize: true,
        onSubmit: async vals => {
            const {subCompanyCode, cariCode, expCode, ...values} = vals;

            try {
                await stores.companyStore.updateSubCompany(values);
            } catch (error) {
                Sentry.captureException(error);
            } finally {
                refetch();
            }
        }
    });

    const {values, handleSubmit, handleChange, isSubmitting} = formik;

    return (
        <Card title="Cari Hesap Bilgileri" style={{marginTop: "10px"}}>
            {loading ? (
                <Skeleton active />
            ) : (
                <Form
                    labelCol={{span: 24}}
                    wrapperCol={{span: 24}}
                    onFinish={data => {
                        handleSubmit(data);
                    }}
                    autoComplete="off"
                    data-testid="billingInformationForm"
                >
                    <Row>
                        <Col span={24}>
                            <Row gutter={[16, 16]}>
                                <Col md={8} sm={24}>
                                    {" "}
                                    <Form.Item>
                                        <h4>Ticari Ünvan</h4>
                                        <Input
                                            disabled={isCustomer}
                                            name="bill.commercialTitle"
                                            onChange={handleChange}
                                            value={values?.bill?.commercialTitle}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col md={8} sm={24}>
                                    <Form.Item>
                                        <h4>Cari Kodu</h4>
                                        <Input
                                            disabled
                                            name="cariCode"
                                            onChange={handleChange}
                                            value={values?.cariCode}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col md={8} sm={24}>
                                    <Form.Item>
                                        <h4>Para Transfer Kodu</h4>
                                        <Input
                                            disabled
                                            name="expCode"
                                            onChange={handleChange}
                                            value={values?.expCode}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]}>
                                <Col md={8} sm={24}>
                                    <Form.Item>
                                        <h4>Vergi Dairesi</h4>
                                        <Input
                                            name="bill.registeredTaxOffice"
                                            onChange={handleChange}
                                            value={values?.bill?.registeredTaxOffice}
                                            disabled={
                                                subCompany?.bill?.registeredTaxOffice !== null &&
                                                subCompany?.bill?.registeredTaxOffice !== "" &&
                                                subCompany?.bill?.registeredTaxOffice !== undefined
                                            }
                                        />
                                    </Form.Item>
                                </Col>
                                <Col md={8} sm={24}>
                                    <Form.Item>
                                        <h4>Vergi Numarası</h4>
                                        <Input
                                            name="bill.taxNumber"
                                            onChange={handleChange}
                                            value={values?.bill?.taxNumber}
                                            disabled={
                                                subCompany?.bill?.taxNumber !== null &&
                                                subCompany?.bill?.taxNumber !== "" &&
                                                subCompany?.bill?.registeredTaxOffice !== undefined
                                            }
                                        />
                                    </Form.Item>
                                </Col>
                                <Col md={8} sm={24}>
                                    <Form.Item>
                                        <h4>Fatura Adresi</h4>
                                        <Input
                                            name="bill.billInformation"
                                            onChange={handleChange}
                                            value={values?.bill?.billInformation}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            {/* <Row gutter={[16, 16]}>
                                <Col md={12} sm={24}>
                                    <Form.Item>
                                        <h4>İl</h4>
                                        <Input
                                            name="city"
                                            onChange={handleChange}
                                            value={values?.city}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col md={12} sm={24}>
                                    <Form.Item>
                                        <h4>İlçe</h4>
                                        <Input
                                            name="county"
                                            onChange={handleChange}
                                            value={values?.county}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row> */}
                            <Row gutter={[16, 16]}>
                                <Col md={12} sm={24}>
                                    <Form.Item>
                                        <h4>Telefon Numarası</h4>
                                        <Input
                                            name="authorizedPhone"
                                            value={values?.authorizedPhone}
                                            maxLength={11}
                                            onChange={e => {
                                                const value = e.target.value.replace(/\D/g, "");
                                                e.target.value = value;
                                                handleChange(e);
                                            }}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col md={12} sm={24}>
                                    <Form.Item>
                                        <h4>E-posta Adresi</h4>
                                        <Input
                                            name="authorizedEmail"
                                            onChange={handleChange}
                                            value={values?.authorizedEmail}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row type="flex" justify="end">
                        <CustomButton
                            loading={isSubmitting}
                            type="ghost"
                            htmlType="submit"
                            data-testid="submitButton"
                            style={{
                                backgroundColor: isCustomer ? "#AEFF01" : "transparent"
                            }}
                        >
                            {t("actions.save", {ns: "common"})}
                        </CustomButton>
                    </Row>
                </Form>
            )}
        </Card>
    );
};
